<template>
  <div class="card-tempo-uso">
    <h3>Barra de tempo de uso</h3>
    <p>{{ subtitle }}</p>

    <div v-if="errorMessage" class="error-banner">
      <span>{{ errorMessage }}</span>
      <button class="btn-fechar-erro" @click="errorMessage = ''">&times;</button>
    </div>

    <div v-if="isLoading" class="estado-vazio">
      <p>Carregando dados...</p>
    </div>

    <div v-else-if="!maquinaId" class="estado-vazio">
      <p>Selecione uma máquina para ver o uso do dia.</p>
    </div>

    <div v-else-if="percentual === null" class="estado-vazio">
      <p>Nenhum dado disponível para esta máquina.</p>
    </div>

    <div v-else class="conteudo-progresso">
      <div class="valor-percentual">{{ percentual }}%</div>
      <div class="label-uso">USO DO DIA</div>

      <div class="barra-container">
        <div class="barra-preenchimento" :style="{ width: Math.min(percentual, 100) + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services'
import { DB_ROUTES } from '@/constants'

export default {
  name: 'MachineUtilization',
  props: {
    maquinaId: {
      type: [String, Number],
      default: null
    },
    dataSelecionada: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      percentual: null,
      equipmentName: '',
      windowStartHour: 8,
      windowEndHour: 18,
      errorMessage: ''
    }
  },
  computed: {
    windowLabel () {
      return `${this.windowStartHour}h e ${this.windowEndHour}h`
    },
    formattedDate () {
      if (this.dataSelecionada) {
        const [year, month, day] = this.dataSelecionada.split('-')
        if (year && month && day) return `${day}/${month}/${year}`
      }
      const today = new Date()
      const day = String(today.getDate()).padStart(2, '0')
      const month = String(today.getMonth() + 1).padStart(2, '0')
      return `${day}/${month}/${today.getFullYear()}`
    },
    subtitle () {
      const janela = this.windowLabel
      if (this.equipmentName) {
        return `Percentual de uso de ${this.equipmentName} entre ${janela} — ${this.formattedDate}`
      }
      return `Percentual de uso da máquina entre ${janela} — ${this.formattedDate}`
    }
  },
  watch: {
    maquinaId: {
      immediate: true,
      handler () {
        this.carregarUso()
      }
    },
    dataSelecionada () {
      this.carregarUso()
    }
  },
  methods: {
    async carregarUso () {
      if (!this.maquinaId) {
        this.percentual = null
        this.equipmentName = ''
        return
      }

      this.isLoading = true
      this.errorMessage = ''

      try {
        const response = await api.get(DB_ROUTES.GET_ANALYSIS_DASHBOARD_EQUIPMENT_USAGE({
          equipmentId: this.maquinaId,
          date: this.dataSelecionada || undefined
        }))

        const data = response.data || {}
        this.percentual = Math.round(Number(data.usagePercent ?? data.UsagePercent ?? 0))
        this.equipmentName = data.equipmentIdentification || data.EquipmentIdentification || ''
        this.windowStartHour = Number(data.windowStartHour ?? data.WindowStartHour ?? 8)
        this.windowEndHour = Number(data.windowEndHour ?? data.WindowEndHour ?? 18)
      } catch (error) {
        console.error('Erro ao carregar uso da máquina:', error)
        this.percentual = null
        this.equipmentName = ''
        this.errorMessage = error.response?.data?.message || 'Não foi possível carregar o uso da máquina.'
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.card-tempo-uso {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  font-family: 'Inter', sans-serif;
  height: 100%;
  box-sizing: border-box;
}

.card-tempo-uso h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.card-tempo-uso p {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #888888;
}

.conteudo-progresso {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.valor-percentual {
  font-size: 36px;
  font-weight: 700;
  color: #FF5722;
  line-height: 1;
}

.label-uso {
  font-size: 11px;
  font-weight: 600;
  color: #888888;
  margin-top: 6px;
  margin-bottom: 24px;
  letter-spacing: 0.5px;
}

.barra-container {
  width: 100%;
  height: 8px;
  background-color: #EFEFEF;
  border-radius: 4px;
  overflow: hidden;
}

.barra-preenchimento {
  height: 100%;
  background-color: #FF5722;
  border-radius: 4px;
  transition: width 0.4s ease;
}

.estado-vazio {
  padding: 40px 0;
  text-align: center;
  color: #888888;
  font-size: 14px;
}

.error-banner {
  background-color: #FEE2E2;
  color: #991B1B;
  padding: 10px 14px;
  border-radius: 6px;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.btn-fechar-erro {
  background: none;
  border: none;
  color: #991B1B;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
</style>
